import { useContext } from 'react';
import { NotificationContext, type NotificationContextValue } from './NotificationContext';

/** Access the notification store. Must be used within <NotificationProvider>. */
export function useNotifications(): NotificationContextValue {
  const ctx = useContext(NotificationContext);
  if (!ctx) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return ctx;
}
